export const YesNo = {
  Yes: 'Y',
  No: 'N',
};
